'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef, createContext } from 'react';

const Context = createContext({
    current: null,
});
/**
 * DialogTriggerContext component, used to provide a context for a dialog trigger.
 *
 * @example
 * <Dialog.TriggerContext>
 *   <Dialog.Trigger>Open Dialog</Dialog.Trigger>
 *   <Dialog>
 *     Content
 *   </Dialog>
 * </Dialog.TriggerContext>
 */
const DialogTriggerContext = ({ children, }) => {
    const contextRef = useRef(null);
    return jsx(Context.Provider, { value: contextRef, children: children });
};
DialogTriggerContext.displayName = 'DialogTriggerContext';

export { Context, DialogTriggerContext };
